import styled from "styled-components";
import { HTMLAttributes } from 'react';

export const Container = styled.div`
  position: relative;
  display: inline-block;
`;

interface HamburgerButtonProps extends HTMLAttributes<HTMLButtonElement> {
  $isOpen: boolean; // use $ prefix to prevent DOM leak
}

export const HamburgerButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== '$isOpen'
})<HamburgerButtonProps>`
  background: none;
  border: none;
  padding: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  z-index: 11;

  div {
    width: 24px;
    height: 3px;
    background-color: white;
    border-radius: 2px;
    margin: 3px 0;
    transition: 0.3s ease;
  }

  ${({ $isOpen }) =>
    $isOpen &&
    `
    div:nth-child(1) {
      transform: rotate(45deg) translate(5px, 5px);
    }
    div:nth-child(2) {
      opacity: 0;
    }
    div:nth-child(3) {
      transform: rotate(-45deg) translate(5px, -5px);
    }
  `}
`;

export const Menu = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  /* Above the sync banner (z-index: 1000 in Header.tsx), which otherwise
     paints over this menu since it comes later in the DOM at the same z-index */
  z-index: 1002;
  padding: 10px;
  min-width: 150px;
  max-width: 90vw;
`;

export const MenuItem = styled.a`
  display: block;
  padding: 8px 12px;
  color: #333;
  text-decoration: none;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #f2f2f2;
  }
`;
